const projectPicture = {

    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
        this.initInputs();
    },

    bindUI: function() {
        this.ui.$projectPictureInput = $('.js-project-picture-input');
        this.ui.$projectPictureSubmit = $('.js-project-picture-submit');
        this.ui.$projectPictureAutocomplete = $ (".js-project-picture-autocomplete");
    },

    bindEvents: function() {
        
        this.ui.$projectPictureSubmit.on('click', this.onProjectPictureSubmitClick.bind(this));
        // this.ui.$projectPictureInput.on('keyup', this.keyupPictureInput.bind(this)); // vu qu'on les créé dinamiquement, il faut le bind autrement
        $("body").on('keyup', '.js-project-picture-input', this.keyupPictureInput.bind(this));
        
        // this.ui.$projectPictureInput.on('keypress', this.hyjackEnterPictureInput.bind(this)); // vu qu'on les créé dinamiquement, il faut le bind autrement
        $("body").on('keypress', '.js-project-picture-submit', this.hyjackEnterPictureInput.bind(this));
        $("body").on('click', ()=>{this.ui.$projectPictureAutocomplete.addClass("js-hide")});
    },
    
    initInputs: function() {
        $('.js-project-picture-reference-input option:selected').each(function(i, el) {
            let $container = $(el).parents('.js-project-picture-container');
            $container.find('.js-project-picture-input').val(el.text);
            // $container.find('.js-project-picture-submit').click();
        });
        $('.js-project-picture-container').each(function(i, el) {
            let $container = $(el);
            if($container.find('.js-project-picture-input').val() !== '') {
                $container.find('.js-project-picture-submit').click();
            }
        });
    },

    hyjackEnterPictureInput: function(e) {
        var $this = $(e.currentTarget);
        if(event.which == '13') {
            event.preventDefault();
            $this.closest('.js-project-picture').find('.js-project-picture-submit').click();
        }
    },
    keyupPictureInput: function(e) {
        var $this = $(e.currentTarget);
        // console.log(event.which);
        if(event.which == '13' || event.which == undefined) {
            event.preventDefault();
            $this.closest('.js-project-picture').find('.js-project-picture-submit').click();
        }else{
            if(event.which != '39' && event.which != '40'){
                $.ajax({
                    method: 'POST',
                    url: $this.attr('data-target-autocomplete'),
                    data: $this.val(),
                    success: (data) => {
                        // console.log("success");
                        if(data.success){
                            // var $datalist = $this.closest('.js-project-picture').find(".js-project-picture-datalist");
                            // $datalist.html("");
                            // for (var i = 0; i < data.results.length; i++) {
                            //     $datalist.append("<option value='"+data.results[i]+"'>"+data.results[i]+"</option>");
                            // }
                            var $autocomplete = $this.closest('.js-project-picture').find(".js-project-picture-autocomplete");
                            $autocomplete.html("").removeClass("js-hide");
                            for (var i = 0; i < data.results.length; i++) {
                                var itemVal = data.results[i];
                                var $autocompleteItem = $("<button type='button' class='projectPictureSearch__autocomplete-item js-project-picture-autocomplete-item' value='"+itemVal+"'>"+itemVal+"</button>");
                                $autocomplete.append($autocompleteItem);
                                $autocompleteItem.on('click', (e)=>{
                                    $this.val(e.currentTarget.value);
                                    $this.focus();
                                    $this.closest('.js-project-picture').find('.js-project-picture-submit').click();
                                });
                            }
                        }
                    },
                    error: (data) => {
                        console.log("error autocomplete");
                    }
                })
            }
        }
    },

    onProjectPictureSubmitClick: function(e) {
        let $this = $(e.currentTarget);
        let $container = $this.parents('.js-project-picture-container');
        let $input = $container.find('.js-project-picture-input')
        const input = $input.val()
        let $product = $container.find('.js-project-picture-product');
        let $productInput = $product.find('.js-project-picture-reference-input');
        let $error = $container.find('.js-project-picture-error')
        $productInput.empty();
        if('' !== input){
            $.ajax({
                method: 'GET',
                url: ($this.data('url')+input),
            }).done(function (data) {
                if('success' === data.status){
                    let $projectPicture = $container.find('.js-project-picture');
                    let $img = $product.find('.js-project-picture-product-img');
                    let $code = $product.find('.js-project-picture-product-code');
                    let $family = $product.find('.js-project-picture-product-family');
                    let $name = $product.find('.js-project-picture-product-name');
                    $projectPicture.addClass('js-hide');
                    $product.removeClass('js-hide');

                    const env = $img.attr('data-env');
                    const path = ('dev' === env ? '' : $img.attr('data-asset-url')) + '/' + data.product.image;

                    $img.attr('src', path);
                    $code.html(data.product.code);
                    $family.html(data.product.family);
                    $name.html(data.product.name);

                    if(data.product.size) {
                        let $catalog = $('.js-from-catalog');
                        $catalog.find(".js-catalog-length").text(data.product.size.length);
                        $catalog.find(".js-catalog-depth").text(data.product.size.depth);
                        $catalog.find(".js-catalog-heightTotal").text(data.product.size.heightTotal);
                        $catalog.find(".js-catalog-heightSeat").text(data.product.size.heightSeat);
                    }

                    $container.find('.js-project-picture-product-delete').click(function (){
                        $projectPicture.removeClass('js-hide');
                        $product.addClass('js-hide');
                        $input.val(null);
                        $img.attr('src', '');
                        $code.html(null);
                        $family.html(null);
                        $name.html(null);
                        $productInput.empty();
                        $productInput.change();
                    })
                    // console.log(data)
                    $productInput.append(`<option value="${data.product.id}" selected>${data.product.code}</option>`);
                    $productInput.change();
                    $error.html("");
                } else if('error' === data.status){
                    $error.html(data.error);
                }
            })
        }
    },
}

module.exports = projectPicture;